import { useTranslation } from "react-i18next";
import { CopyOrange } from "../../assets/svgs";
import { ToastService } from "../../services/toaster.service";
import "./styles.scss";

const PaymentMethodCard = ({ data = {} }) => {
  const { t } = useTranslation();

  const sadad = data?.sadad;
  const iban = data?.IBAN;
  const ibanProvider = data?.iban_provider;

  const paymentData = [
    sadad && {
      title: "Sadad Number",
      description: "Use this SADAD number for payment",
      value: sadad,
      bankName: "",
    },
    iban && {
      title: "IBAN Number",
      description: "Use this IBAN for bank transfer",
      value: iban,
      bankName: ibanProvider || "",
    },
  ].filter(Boolean);

  const handleOnClickCopy = async (item) => {
    await navigator.clipboard.writeText(item.value);
    ToastService.info(
      t("global.payment_method_copied_message", { title: item.title }),
      { icon: false }
    );
  };

  return (
    <>
      {paymentData.map((item) => (
        <div className="payment-method-card">
          <p className="payment-method-card-title">{item.title}</p>

          <p className="payment-method-card-description">{item.description}</p>

          <div className="payment-method-copy-card">
            <p className="payment-method-card-value">{item.value}</p>
            <img
              src={CopyOrange}
              alt="copy-icon"
              className="payment-method-copy-icon"
              onClick={() => handleOnClickCopy(item)}
            />
          </div>

          {item.bankName && (
            <p className="payment-method-card-bank">{item.bankName}</p>
          )}
        </div>
      ))}
    </>
  );
};

export default PaymentMethodCard;
